"use client";
import React from "react";
import "./Banner.css";
import Link from "next/link";
import { useAuth } from "@/context/AuthProvider";
import { usePathname } from "next/navigation";

function Banner({ patternStrings }) {
  const { userData } = useAuth();
  const pathname = usePathname();

  /* 1 ▪ hide on the routes you passed in */
  const hideByRoute = patternStrings.withoutBanner
    .map((s) => new RegExp(s, "i"))
    .some((rx) => rx.test(pathname));

  if (hideByRoute) return null;
  if (!userData) return;
  if (userData?.companyInformation?.verified) return;

  return (
    <div className="CompanyBanner">
      <div className="CompanyBanner-wrapper">
        <span className="CompanyBanner-title">
          Unternehmensinformationen einreichen
        </span>

        <div className="CompanyBanner-text-wrapper">
          <span className="CompanyBanner-text">
            Um Zugriff auf alle Bereiche der Plattform zu erhalten,&nbsp;
          </span>
          <Link
            href="/profil/unternehmensinformation"
            className="CompanyBanner-link"
          >
            vervollständige und reiche deine Unternehmensinformationen ein.
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Banner;
